import { cx } from 'emotion';
import React, { useEffect, useState } from 'react';
import { getVimeoEmbedUrl, isVimeoShowcaseUrl } from '../../utils';
import { Iframe } from './Iframe';

interface Props {
    data?: { video?: { embedUrl: string } };
}

export const VideoModule: React.FC<Props> = ({ data }) => {
    const videoUrl = data?.video?.embedUrl || '';
    const isVimeoShowcase = isVimeoShowcaseUrl(videoUrl);
    const [vimeoVideoUrl, setVimeoVideoUrl] = useState(videoUrl);

    useEffect(() => {
        if (isVimeoShowcase) {
            getVimeoEmbedUrl(videoUrl).then((url) => {
                setVimeoVideoUrl(url);
            });
        }
    }, [videoUrl, isVimeoShowcase]);

    return (
        <div className={cx('dc-modules__item--video')}>
            <Iframe
                data-spec="video-iframe"
                url={isVimeoShowcase ? vimeoVideoUrl : videoUrl}
            />
        </div>
    );
};
